import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const PATTERN = /^https:\/\/www\.figma\.com\/.*/;

const DEFAULT_WIDTH = '800px';
const DEFAULT_HEIGHT = '450px';

export const matchFigma: ProviderMatcher = (url, params) => {
	if (!PATTERN.test(url)) {
		return null;
	}
	const embedUrl = `${url.replace('www', 'embed')}&embed-host=confluence-cloud`;
	return {
		kind: 'iframe',
		provider: 'Figma',
		embedUrl,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
